export default __webpack_public_path__ + "static/media/Logo_Trust_SCAS@3x.5a3f4ec0.png";